const {addItemsToCart, modifyCart} = require("./CartUtil");
const {$find, getCookie, showModal} = require("./ElevHelpers");
const {v4: uuidv4} = require("uuid");
const _ = require("lodash");

function getInputFields() {
	const recipientEl = _.first($find(document, ".subsection-recipient-info"));
	if (!recipientEl) {
		return;
	}
	const recipientEmailEl = recipientEl.querySelector(".recipient-email-input");
	const senderNameEl = recipientEl.querySelector(".sender-name-input");
	const studentNameEl = recipientEl.querySelector(".student-name-input");
	const deliveryDateEl = recipientEl.querySelector(".delivery-date-input");
	const personalizedMessageEl = recipientEl.querySelector(
		".personalized-message-input"
	);
	return {
		recipientEmailEl,
		senderNameEl,
		studentNameEl,
		deliveryDateEl,
		personalizedMessageEl,
	};
}

function computeCartItem() {
	const inputFields = getInputFields();
	const nameError = document.getElementById("name-error-message");
	const emailError = document.getElementById("email-error-message");
	const dateError = document.getElementById("date-error-message");
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const isNameValid = validateField(inputFields.senderNameEl, nameError);
	const isEmailValid = validateField(
		inputFields.recipientEmailEl,
		emailError,
		emailRegex
	);
	const deliveryDateInfo = processDateField(
		inputFields.deliveryDateEl,
		dateError
	);

	if (!isNameValid || !isEmailValid || !deliveryDateInfo.valid) {
		return;
	}

	const inputValues = _.mapValues(inputFields, el => el.value);
	const cartOptions = _.mapKeys(inputValues, (_value, key) => {
		return key.slice(0, -2);
	});
	cartOptions["deliveryDateUTC"] = deliveryDateInfo.deliveryDateUTC;

	const selectedProduct = document.querySelector(
		'input[name="product-selector"]:checked'
	);
	if (!selectedProduct) {
		return;
	}
	const sku = selectedProduct.getAttribute("item-sku");
	return {
		sku: sku,
		quantity: 1,
		options: {...cartOptions, uniqueId: uuidv4()},
	};
}

function validateField(field, errorElement, regex = null) {
	const isValid = field.value.trim() && (!regex || regex.test(field.value));
	if (isValid) {
		field.classList.remove("input-error");
		errorElement.classList.remove("visible");
	} else {
		field.classList.add("input-error");
		errorElement.classList.add("visible");
		field.focus();
	}
	const clearError = () => {
		field.classList.remove("input-error");
		errorElement.classList.remove("visible");
		field.removeEventListener("input", clearError);
	};
	field.addEventListener("input", clearError);
	return isValid;
}

/*
 * Returns an object {valid: boolean, deliveryDateUTC: Date || ""}
 * Checks whether the date is in the past; if so, then valid is false.
 * If no date is specified, the input is valid, and the email will be
 * sent immediately, so deliveryDateUTC is an empty string.
 * If the date is specified and is valid, deliveryDateUTC is the UTC
 * timestamp at which the email will be sent (midnight in the purchaser's
 * timezone on the specified date).
 */
function processDateField(field, errorElement) {
	if (field.value === "") {
		return {valid: true, deliveryDateUTC: ""};
	}

	const currentDatetime = new Date();
	let currentLocalDate = currentDatetime.toLocaleDateString();
	currentLocalDate = new Date(currentLocalDate);

	const inputDateString = field.value + " 00:00:00";
	const inputTimeToSend = new Date(inputDateString);

	const isValid = inputTimeToSend >= currentLocalDate;
	if (isValid) {
		field.classList.remove("input-error");
		errorElement.classList.remove("visible");
	} else {
		field.classList.add("input-error");
		errorElement.classList.add("visible");
		field.focus();
	}
	const clearError = () => {
		field.classList.remove("input-error");
		errorElement.classList.remove("visible");
		field.removeEventListener("input", clearError);
	};
	field.addEventListener("input", clearError);
	return {valid: isValid, deliveryDateUTC: inputTimeToSend};
}

function resetForm() {
	const {
		recipientEmailEl,
		senderNameEl,
		studentNameEl,
		deliveryDateEl,
		personalizedMessageEl,
	} = getInputFields();
	recipientEmailEl.value = "";
	senderNameEl.value = "";
	studentNameEl.value = "";
	deliveryDateEl.value = "";
	personalizedMessageEl.value = "";
}

// MODAL helper functions
const openModal = modalID => {
	const el = document.querySelector(`#${modalID}`);
	el.style.display = "flex";
	setTimeout(() => (el.style.opacity = 1), 50);
};

const closeModal = modalID => {
	const el = document.querySelector(`#${modalID}`);
	el.style.opacity = 0;
	setTimeout(() => {
		el.style.display = "none";
	}, 500);
};

function setupForClassWallet() {
	const cwCookie = getCookie("cw");
	if (!cwCookie) {
		return;
	}
	const subsNotAvailableModal = $find(
		document,
		".modal-wrapper.gifts-not-available"
	)[0];

	document.querySelector(".add-to-cart-btn")?.addEventListener("click", evt => {
		const modalToShow = subsNotAvailableModal;
		showModal(modalToShow, evt);
	});
}

const setupAddToCart = () => {
	const addToCartButton = document.querySelector(
		".gifting-btn.add-to-cart-btn"
	);
	if (!addToCartButton) {
		return;
	}
	addToCartButton.onclick = () => {
		const itemToAdd = computeCartItem();
		if (itemToAdd) {
			modifyCart(cart => {
				addItemsToCart([itemToAdd], cart);
			});
			openModal("gifting-added-to-cart-modal");
			resetForm();
		}
	};

	// close schedule modal if a. is displaying and b. user clicked out
	document.addEventListener("click", e => {
		// if modal open
		const addedToCartModal = document.querySelector(
			"#gifting-added-to-cart-modal"
		);

		if (addedToCartModal) {
			if (
				addedToCartModal.style.display &&
				addedToCartModal.style.display !== "none"
			) {
				// if the click is outside the modal (the modal is a child), close it
				if (
					e.target.classList.contains("modal-close") ||
					e.target.contains(addedToCartModal)
				) {
					closeModal("gifting-added-to-cart-modal");
				}
			}
		}
	});
};

const setupGiftingPage = () => {
	const cwCookie = getCookie("cw");
	if (cwCookie) {
		setupForClassWallet();
	} else {
		setupAddToCart();
	}

	const deliveryDateInput = document.querySelector("input.delivery-date-input");
	if (!deliveryDateInput) return;
	deliveryDateInput.addEventListener("focus", e => {
		e.target.style = "color:#262626";
	});
	deliveryDateInput.addEventListener("focusout", e => {
		if (!e.target.value) {
			e.target.style = "color:#797c80";
		}
	});
};

module.exports = {
	setupGiftingPage,
};
